export const createTableRowId = (id) => `TABLE_ROW_${id}`;
